import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormAdditive from './Form/FormAdditive'

function NewAdditive({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerAdditive(additive) {
        let msgType = 'success'

        const data = await api.post('/additive/new', additive, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormAdditive title="Cadastrar Aditivo" handleSubmit={registerAdditive} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewAdditive
